var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content s-character"},[_c('h3',{staticClass:"title-p"},[_vm._v(_vm._s(_vm.leftTitle))]),_vm._l((_vm.items),function(item){return _c('div',{key:item.index},[_c('h5',[_vm._v(_vm._s(item['title_2']))]),_c('el-divider'),_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(item.content)}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }